import type { WhatsAppUsageResponseTypes } from "backend";
import type { Requests } from "../common/request.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { buildSelectParam, get, post } from "./common";

export const whatsAppUsage = {
    record(month?: string) {
        return (data: typeof Requests.WhatsAppUsage.Record.Input) => {
            return post<typeof data, WhatsAppUsageResponseTypes.Record>(
                `/whatsapp-usage/record/${month ?? ""}`,
                data,
            );
        };
    },
    formHooks: {
        select: (async (param?: SelectParam) => {
            const req = get<WhatsAppUsageResponseTypes.Select>(
                `/whatsapp-usage/select` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
    },
};
